"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var KeyboardTypeEnum;
(function (KeyboardTypeEnum) {
    KeyboardTypeEnum["default"] = "default";
    KeyboardTypeEnum["numberPad"] = "number-pad";
    KeyboardTypeEnum["decimalPad"] = "decimal-pad";
    KeyboardTypeEnum["numeric"] = "numeric";
    KeyboardTypeEnum["emailAddress"] = "email-address";
    KeyboardTypeEnum["phonePad"] = "phone-pad";
})(KeyboardTypeEnum = exports.KeyboardTypeEnum || (exports.KeyboardTypeEnum = {}));
